import { makeStyles } from "@material-ui/core/styles"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	label: {
		fontSize: 14,
		fontWeight: 600,
		marginRight: theme.spacing(1)
	},
	chip: {
		marginLeft: theme.spacing(1),
		backgroundColor: colors.purple[200],
		fontWeight: 400,
		fontSize: 12
	},
	description: {
		color: colors.gray[300],
		fontSize: 13
	},
	root: {
		marginTop: theme.spacing(1)
	},
	icon: {
		cursor: "pointer",
		color: colors.gray[400],
		width: 14
	}
}))

export default useStyles
